import {
    CUSTOMER_SUCCESS,
    CUSTOMER_LOADING,
    TABLE_LOADING,
} from '../actions/customerAction';

const initialState = {
    amazon: {
        customersData: null,
        isLoading: true,
        isTableLoading: true
    },
    shopify: {
        customersData: null,
        isLoading: true,
        isTableLoading: true
    },
    wholesale: {
        customersData: null,
        isLoading: true,
        isTableLoading: true
    }
};

const customerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case CUSTOMER_SUCCESS:
            return {
                ...state, [action?.vendor]: { customersData: action.data, isLoading: false, isTableLoading: false }
            };
        case CUSTOMER_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };
        case TABLE_LOADING:
            return {
                ...state, [action?.vendor]: {
                    ...state?.[action?.vendor],
                    isTableLoading: action.isTableLoading
                }
            };

        default:
            return state;
    }
};

export default customerReducer;